<template>
  <EditContactsPage
    :get-gql-query="getGqlQuery"
    :get-total-count="getTotalCount"
    :get-contacts="getContacts"
    :get-query-variables="getQueryVariables"
    :update-query-variable="updateQueryVariable"
  />
</template>

<script>
import EditContactsPage from '@/pages/Contact/EditContactsPage'
import { LIST_EDIT_INTEREST_CONTACTS } from '@/backend/graphql/interestGQL'
export default {
  name: 'EditInterestContactsPage',
  components: {
    EditContactsPage
  },
  data: function () {
    return {
      getGqlQuery: LIST_EDIT_INTEREST_CONTACTS,
      limit: 50,
      offset: 0,
      orderBy: '-profile__id,-profile__last_recv_at',
      interestId: 0,
      profileIsDelete: 0
    }
  },
  created () {
    this.interestId = this.$route.params.interestId
  },
  methods: {
    getTotalCount (data) {
      return data.listInterestProfile.totalCount
    },
    getContacts (data) {
      return data.listInterestProfile.results.map(obj => obj.profile)
    },
    getQueryVariables () {
      return {
        limit: this.limit,
        offset: this.offset,
        orderBy: this.orderBy,
        interestId: this.interestId,
        profileIsDelete: this.profileIsDelete
      }
    },
    updateQueryVariable (key, value) {
      if (this.hasOwnProperty(key)) {
        this[key] = value
      }
    }
  }
}
</script>

<style scoped>

</style>
